import * as angular from 'angular';
import {IController, IScope} from 'angular';
import {SplitService} from "./modules/commons/services/split-service.service";
import {SsoConfigModel} from "./modules/authentication/models/sso-config.model";
import {IamRequests} from "./modules/iam/factories/iam-requests.service";
export class AppComponentCtrl implements IController {

  public loading: boolean;
  public initialized: boolean = false;
  public ssoConfig: SsoConfigModel;
  public isConfigurationClientReady: boolean = false;

  /* @ngInject */
  constructor(private $scope: IScope, private $timeout, private IamRequests: IamRequests) {
  }

  $onInit() {
    const isLoggedIn: boolean = !!(localStorage.getItem('admin_token') || localStorage.getItem('access_token'));
    const isNavigatingToLogin: boolean = window.location.pathname === '/login';

    const configClientPromise = this.IamRequests.getConfigurationClient()
      .then((ssoConfig: SsoConfigModel) => {
        this.IamRequests.setSsoConfig(ssoConfig);
        this.ssoConfig = ssoConfig;
      });

    if (isLoggedIn && !isNavigatingToLogin) {
      // Already authenticated and not headed to the login screen - don't block the initial render on SSO config, load it in the background.
      this.isConfigurationClientReady = true;
    } else {
      // Not logged in, or headed to the login screen - it needs SSO config to know what to render.
      configClientPromise.finally(() => {
        this.isConfigurationClientReady = true;
      });
    }

    configClientPromise.finally(() => {
      this.loading = false;
    });

    this.loading = true;

    // watch for ui router state change end - Success
    this.$scope.$on('$stateChangeSuccess', this.onStateChangeEnd.bind(this));
  }

  onBootstrap() {
    this.initialized = true;
    this.$timeout(() => {}, 0)
  }

  private onStateChangeEnd(event, toState, toParams, fromState, fromParams) {
    this.loading = false;
  }

}

angular
  .module('app')
  .component('appComponent', {
    bindings: {},
    template: require('./app-component.html').default,
    controller: AppComponentCtrl
  });
